// FastAPI sends `detail` as a string for HTTPException, but as an array of
// {loc, msg, type} objects for request-validation (422) failures. Rendering
// that array straight into JSX crashes React ("Objects are not valid as a
// React child"), so flatten it to a sentence.
export function detailToMessage(detail) {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => (d?.msg || '').replace(/^Value error, /, ''))
      .filter(Boolean)
      .join(' ');
  }
  return '';
}
